import { defineMessages } from 'react-intl'

export default defineMessages({
  heading: {
    defaultMessage: 'Tack för ditt svar!',
    id: 'feedback.success.heading',
  },
  lede: {
    defaultMessage:
      'Ditt svar hjälper oss att förbättra vår verksamhet och att bygga bättre produkter för dig och ditt företag. Ha en fortsatt bra dag 🎉',
    id: 'feedback.success.lede',
  },
})
